class WishlistDrawerComponent extends HTMLElement {
    connectedCallback() {
        this.dialog = this.querySelector("dialog");
        this.addEventListener("click", this.#onClick);
        // Close when clicking on the backdrop area
        this.dialog?.addEventListener("click", this.#onDialogBackdropClick);
        // Allow ESC to close (native does this, but ensure consistency)
        this.dialog?.addEventListener("cancel", (e) => {
            // Some browsers close automatically; ensure we call our close for consistency
            try {
                e.preventDefault();
            } catch (_) {}
            this.close();
        });
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.#onClick);
        this.dialog?.removeEventListener("click", this.#onDialogBackdropClick);
    }

    /** @param {MouseEvent} e */
    #onClick = (e) => {
        const el = /** @type {Element | null} */ (e.target instanceof Element ? e.target : null);
        const t = el?.closest("[on\\:click]");
        if (!t) return;
        const action = t.getAttribute("on:click");
        if (action === "wishlist-drawer-component/open") {
            e.preventDefault();
            this.open();
        }
        if (action === "wishlist-drawer-component/close") {
            e.preventDefault();
            this.close();
        }
    };
    /** @param {MouseEvent} e */
    #onDialogBackdropClick = (e) => {
        // When clicking on the ::backdrop, the event target is the dialog element
        if (e.target === this.dialog) {
            e.preventDefault();
            this.close();
        }
    };
    open() {
        this.dialog?.showModal?.();
        // Ask wishlist.js to render into any visible wishlist containers (drawer/page)
        document.dispatchEvent(new CustomEvent("wishlist:open"));
    }
    close() {
        const dlg = this.dialog;
        if (!dlg) return;
        if (!dlg.open) return;
        // Add closing class to trigger CSS animation (matches cart/dialog behavior)
        dlg.classList.add("dialog-closing");
        const onEnd = () => {
            try {
                dlg.close();
            } catch (_) {}
            dlg.classList.remove("dialog-closing");
            dlg.removeEventListener("animationend", onEnd);
        };
        dlg.addEventListener("animationend", onEnd);
    }
}

if (!customElements.get("wishlist-drawer-component")) {
    customElements.define("wishlist-drawer-component", WishlistDrawerComponent);
}
